import { TableColumn } from "@/components/Table/Table";

import { ListPerson } from "../../schema/list";

import { renderOutreachColumn } from "./OutreachColumn";

interface InsertOutreachColumnArgs {
	/** Translation helper for the column title. */
	ts: (key: string) => string;
	/** Open the lead's chat (drafts / manual composer / reply thread). */
	onOpenChat?: (row: ListPerson) => void;
}

/**
 * Insert the shared {@link renderOutreachColumn Outreach column} (the state-driven reach-out
 * button + menu) directly after the "name" column of a leads table.
 *
 * Centralising it here — instead of baking it into each per-list-type column config (General /
 * LinkedIn post / profile / event / company-activity / Maps / Jobs / Funding) — is what makes the
 * Outreach affordance appear consistently across **every** list type.
 *
 * - No-op when the config has no "name" column (e.g. a company-only Google-Maps view has no person
 *   to reach out to — {@link renderOutreachColumn}'s cell renders nothing for prospect-less rows).
 * - Idempotent: if an Outreach column is already present the list is returned unchanged.
 */
export const insertOutreachColumn = (
	columns: TableColumn[],
	{ ts, onOpenChat }: InsertOutreachColumnArgs
): TableColumn[] => {
	if (columns.some((column) => column.uid === "outreach")) {
		return columns;
	}

	const nameIndex = columns.findIndex((column) => column.uid === "name");

	if (nameIndex === -1) {
		return columns;
	}

	const next = [...columns];

	next.splice(nameIndex + 1, 0, renderOutreachColumn(ts, onOpenChat));

	return next;
};
